'use strict';

export default (array) => [...new Set(array)];
